import { render, staticRenderFns } from "./NotificationCount.vue?vue&type=template&id=03c949ca&scoped=true"
import script from "./NotificationCount.vue?vue&type=script&lang=js"
export * from "./NotificationCount.vue?vue&type=script&lang=js"
import style0 from "./NotificationCount.vue?vue&type=style&index=0&id=03c949ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c949ca",
  null
  
)

export default component.exports